module.exports = __webpack_public_path__ + "static/media/v2.14055a0b.jpg";